import React from 'react';

import { getProjectLayoutModel } from '../../store/selectors/getProjectLayoutModel';
import { useAppSelector } from '../hooks';
import { MiscContextHeaderToolbar } from './MiscContextHeaderToolbar';
import { ProjectContextHeaderToolbar } from './ProjectContextHeaderToolbar';
import { SharedComponentSetContextHeaderToolbar } from './SharedComponentSetContextHeaderToolbar';
import { StationContextHeaderToolbar } from './StationContextHeaderToolbar';

export function ContextToolbar() {
  const context = useAppSelector((state) => state.application.openContext);
  const project = useAppSelector(getProjectLayoutModel);
  const sharedComponentSet = useAppSelector((state) => state.sharedComponentSet.sharedComponentSet);

  switch (context?.type) {
    case 'project':
      return project ? <ProjectContextHeaderToolbar project={project} /> : null;

    case 'shared-component-set':
      return sharedComponentSet ? (
        <SharedComponentSetContextHeaderToolbar sharedComponentSet={sharedComponentSet} />
      ) : null;

    case 'station':
    case 'schedule-station':
      return <StationContextHeaderToolbar />;

    default:
      return <MiscContextHeaderToolbar />;
  }
}
